import dayjs from 'dayjs'

export const determineStaleTask = (time: string) => {
  const createdDate = dayjs(time)
  const currentMonth = dayjs().month()
  const currentYear = dayjs().year()
  const isStaleTask = !(createdDate.year() === currentYear && createdDate.month() === currentMonth)
  return isStaleTask ?? false
}
